import $ from "jquery";
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Input } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';

import View from './view';
import Edit from './edit';
import Loading from '../../loading';
import Errordialog from '../../errordialog';
import Server from '../../../functions/server';

class Permission extends React.Component {

  state = {
    executiveMenu: [], errorDialog: false,
  }

  componentDidMount() {
    this.getMenucontrol();
  }

  getMenucontrol() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive Controls!!!', roleAddDialog: false });
    $.ajax({
      type: 'POST', url: Server() + 'executivemenu/get.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          context.setState({ executiveMenu: data, load: false })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }

  closeErrorDialog() { this.setState({ errorDialog: false }); }

  updates(data) { this.setState({ executiveMenu: data }) }

  onChange = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  addrole() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'role': context.state.role }, url: Server() + 'executivemenu/addrole.php',
      success: function (data) {
        if (data == 1) {
          context.getMenucontrol();
        }
        else {
          alert('Error')
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }

  render() {
    let i = 1;
    let menuOption = [
      { key: 'Place Order', text: 'Place Order', value: 'place-order' },
      { key: 'Customer Order', text: 'Customer Order', value: 'customer-order' },
      { key: 'Quotation', text: 'Quotation', value: 'quotation' },
      { key: 'Invoice', text: 'Invoice', value: 'invoice' },
      { key: 'JobCard', text: 'JobCard', value: 'job-card' },
      { key: 'JobCard Report', text: 'JobCard Report', value: 'job-card-report' },
      { key: 'Credit Note', text: 'Credit Note', value: 'credit-note' },
      { key: 'Stock Transfer', text: 'Stock Transfer', value: 'stock-transfer' },
      { key: 'Sales Report', text: 'Sales Report', value: 'sales-report' },
      { key: 'Customer Statement', text: 'Customer Statement', value: 'customer-statement' },

      { key: 'Purchase Request', text: 'Purchase Request', value: 'purchase-request' },
      { key: 'Purchase Details', text: 'Purchase Details', value: 'purchase-details' },
      { key: 'Stock Level', text: 'Stock Level', value: 'stock-level' },
      // { key: 'Debit Notes', text: 'Debit Notes', value: 'debit-notes' },
      { key: 'Stock Info', text: 'Stock Info', value: 'stock-info' },
      { key: 'Analytics', text: 'Analytics', value: 'analytics' },
      { key: 'Stock Audit', text: 'Stock Audit', value: 'stock-audit' },
      { key: 'Purchaser Statement', text: 'Purchaser Statement', value: 'purchaser-statement' },

      { key: 'Receipt', text: 'Receipt', value: 'receipt' },
      { key: 'Payment', text: 'Payment', value: 'payment' },
      { key: 'Expense', text: 'Expense', value: 'expense' },
      { key: 'Chitta', text: 'Chitta', value: 'chitta' },
      { key: 'Journal', text: 'Journal', value: 'journal' },
      { key: 'Expense Report', text: 'Expense Report', value: 'expense-report' },
      { key: 'HSNCode Report', text: 'HSNCode Report', value: 'hsncode-report' },
      { key: 'GST Sales REPORT', text: 'GST Sales REPORT', value: 'gst-sales-report' },
      { key: 'GST Purchase Report', text: 'GST Purchase Report', value: 'gst-purchase-report' },

      { key: 'Machine', text: 'Machine', value: 'machine' },
      { key: 'Machine Model', text: 'Machine Model', value: 'machine-model' },
      { key: 'Machine Customer', text: 'Machine Customer', value: 'machine-customer' },
      { key: 'Enquiry Customer', text: 'Enquiry Customer', value: 'enquiry-customer' },
      
      { key: 'Machine Quotation', text: 'Machine Quotation', value: 'machine-quotation' },
      { key: 'Machine Invoice', text: 'Machine Invoice', value: 'machine-invoice' },
      { key: 'Machine Receipt', text: 'Machine Receipt', value: 'machine-receipt' },
      { key: 'Machine Payment', text: 'Machine Payment', value: 'machine-payment' },
      { key: 'Machine Service', text: 'Machine Service', value: 'machine-service' },
      { key: 'Machine Customer Statment', text: 'Machine Customer Statment', value: 'machine-customer-statement' },
      { key: 'Service Type', text: 'Service Type', value: 'service-type' },
      { key: 'Service History', text: 'Machine History', value: 'service-history' },

      { key: 'Add Parts', text: 'Add Parts', value: 'add-parts' },
      { key: 'Add Customer', text: 'Add Customer', value: 'add-customer' },
      { key: 'AddPurchaser', text: 'Add Purchaser', value: 'add-purchaser' },
      { key: 'Combo', text: 'Combo', value: 'combo' },
      { key: 'Expense Master', text: 'Expense Master', value: 'expense-master' },
      { key: 'Executive Web Branch Mapping', text: 'Executive Web Branch Mapping', value: 'executive-web-branch-mapping' },
      { key: 'Web Payment Mode Mapping', text: 'Web Payment Mode Mapping', value: 'web-payment-mode-mapping' },
      { key: 'Discount Menu', text: 'Discount Menu', value: 'discount-menu' },
      { key: 'SMS', text: 'SMS', value: 'sms' },

      { key: 'Executive Control', text: 'Executive Control', value: 'executive-control' },
      { key: 'Executive App Branch Mapping', text: 'Executive App Branch Mapping', value: 'executive-app-branch-mapping' },
      { key: 'App Payment Mode Mapping', text: 'App Payment Mode Control', value: 'app-payment-mode-mapping' },
      { key: 'Edit Bank Details', text: 'Edit Bank Details', value: 'edit-bank-details' },
      { key: 'Edit UPI Details', text: 'Edit UPI Details', value: 'edit-upi-details' },
      { key: 'Offers Scroll', text: 'Offers Scroll', value: 'offers-scroll' },

      { key: 'Executive', text: 'Executive', value: 'executive' },
      { key: 'Labor', text: 'Labor', value: 'labor' },
      { key: 'Add Menu', text: 'Add Menu', value: 'add-menu' },
      { key: 'Brand Control', text: 'Brand Control', value: 'brand-control' },
      { key: 'Customer Type', text: 'Customer Type', value: 'customer-type' },
      { key: 'Customer Type Mapping', text: 'Customer Type Mapping', value: 'customer-type-mapping' },
      { key: 'Point Settings', text: 'Point Settings', value: 'point-settings' },
      { key: 'Notification', text: 'Notification', value: 'notification' },
      { key: 'Statement Mapping', text: 'Statement Mapping', value: 'statement-mapping' },
      { key: 'Web Access', text: 'Web Access', value: 'web-access' },
      
      { key: 'Tickets', text: 'Tickets', value: 'tickets' },
      { key: 'Dashboard', text: 'Dashboard', value: 'dashboard' },
      {key: 'Chart Dashboard', text: 'Chart Dashboard', value: 'chart-dashboard'},
    ]
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Errordialog load={this.state.errorDialog} message={this.state.errormessage} close={this.closeErrorDialog.bind(this)} />
        <br />
        <div style={{ padding: '1%' }}>
          <Button onClick={ () => { this.setState({ roleAddDialog: true }) }}>Add Role</Button><br/><br/>
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
            open={this.state.roleAddDialog} onClose={ () => { this.setState({ roleAddDialog: false }) }}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Sub Menu Controls</DialogTitle>
            <DialogContent>
              <Input placeholder='Role' onChange={this.onChange('role')} value={this.state.role} />
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ roleAddDialog: false }) }}>close</Button><br/><br/>
              <Button onClick={this.addrole.bind(this)}>Submit</Button><br/><br/>
            </DialogActions>
          </Dialog>
          <table id="table" width="100%">
            <tr>
              <th id='th' width='4%'><center>sino</center></th>
              <th id='th' width='10%'><center>Roles</center></th>
              <th id='th' width='83%'><center>Control</center></th>
              <th id='th' width='3%'><center>Edit</center></th>
            </tr>
            {this.state.executiveMenu.map((z) => {
              if (z.type == 'employees') {
                return (
                  <tr>
                    <td><center>{i++}</center></td>
                    <td><center>{z.name}</center></td>
                    <td><center><View menuOption={menuOption} data={this.state.executiveMenu} id={z.id} /></center></td>
                    <td id='pointer'>
                      <center>
                        <Edit menuOption={menuOption} updateMenuControls={this.props.updateMenuControls}
                          updates={this.updates.bind(this)} data={this.state.executiveMenu}
                          id={z.id} />
                      </center>
                    </td>
                  </tr>
                )
              }
            })
            }
          </table>
        </div>
      </div>
    );
  }
}

export default Permission;
